import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FeedbackComment from "pages/conductLegalResearch/fragments/feedBackComment";
import ResponseInput from "pages/conductLegalResearch/fragments/responseInput";
import SectionHeader from "pages/conductLegalResearch/fragments/sectionHeader";
import { formatDate } from "utils/helpers";
import { useAuth } from "contexts/AuthContext";
import EvaluationModal from "components/EvaluationModal";
import { registerEvaluationApi } from "services/directiveEvaluationService";

interface Feedback {
    id: number;
    research_request: number;
    given_by: string;
    role: string;
    feedback_type: string;
    note: string;
    status: string;
    // add any other fields your API returns
}

export default function MainRightPanel({ request }: { request: any }) {
    const [formState, setFormState] = useState({ ...request });
    const { t } = useTranslation();
    const contextData = useAuth();
    const [feedbacks, setFeedbacks] = useState<Feedback[]>(formState?.feedbacks || []);
    const [respondbackFeedbacks, setRespondbackFeedback] = useState<Feedback[]>(request?.respond_back_feedbacks || []);
    const [state, setState] = useState("feedback");
    const [showEvaluation, setShowEvaluation] = useState(false);
    useEffect(() => { }, [formState])

    const canEvaluate =
        contextData?.user?.user_type !== "external" &&
        (request?.prosecutor_assignments?.length ?? 0) > 0 &&
        contextData?.user?.roles?.some(
            (role: string) =>
                role === "LegalResearchCoordinator" || role === "LRDIFUDDirector"
        );
    const bearer = contextData.token || contextData?.user?.access_token || "";
    const evaluatedBy =
        contextData?.user?.full_name ||
        contextData?.user?.first_name ||
        contextData?.user?.user_id;

    return (
        <div className="overflow-y-scroll scrollbar-hide flex w-[45%] flex-col bg-white rounded-lg shadow-md p-6">
            <div className="flex gap-4 items-center pb-2 mb-4 border-b-2">
                <p onClick={() => setState("feedback")} className={`cursor-pointer font-semibold ${state === "feedback" ? "text-base text-white bg-black p-2 rounded-lg" : "text-base text-gray-400"}`}>{t("Feedback")}</p>
                <p onClick={() => setState("respondback")} className={`cursor-pointer font-semibold ${state === "respondback" ? "text-base text-white bg-black p-2 rounded-lg" : "text-base text-gray-400"}`}>{t("RespondBack")}</p>
                {canEvaluate && (
                    <button
                        onClick={() => setShowEvaluation(true)}
                        className="ml-auto flex items-center gap-1.5 text-sm font-semibold text-[#9B0505] border border-[#9B0505] rounded-lg px-3 py-1.5 hover:bg-[#9B0505] hover:text-white transition"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-6m4 6V7m4 10v-3M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                        {t("EvaluateTeam") || "Evaluate Team"}
                    </button>
                )}
            </div>
            {showEvaluation && (
                <EvaluationModal
                    requestId={request.id}
                    teamMembers={request?.prosecutor_assignments || []}
                    evaluatedBy={evaluatedBy}
                    bearer={bearer}
                    api={registerEvaluationApi}
                    onClose={() => setShowEvaluation(false)}
                />
            )}
            {/* Feedback Comments */}
            <div className="overflow-y-scroll scrollbar-hide flex-1 space-y-6 mb-6">
                {state === "feedback" ? (
                    <>
                        {feedbacks.map((feedback: any) => (
                            <FeedbackComment
                                key={feedback.id}
                                name={feedback.given_by}
                                role={feedback.role}
                                commentedDate={formatDate(feedback.created_at)}
                                comment={feedback.note}
                            />
                        ))}
                        {feedbacks.length === 0 && (
                            <p className="text-center my-auto">{t("NoFeedbackYet")}</p>
                        )}
                    </>
                ) : (
                    <>
                        {respondbackFeedbacks?.slice().reverse().map((feedback: any) => (
                            feedback.feedback_type !== "stakeholder_request" &&
                            <FeedbackComment
                                key={feedback.id}
                                name={feedback.given_by}
                                role={feedback.role}
                                commentedDate={formatDate(feedback.created_at)}
                                comment={feedback.note}
                                file={feedback.documents || feedback.uploaded_files || feedback.respond_back_feedback_files}
                                file_type="reg_dir_respond_back_ile"
                                file_url="directive_registration/directive-respond-back-feedback-files/document/"
                                status={feedback.feedback_type}
                            />
                        ))}
                        {respondbackFeedbacks.length === 0 && (
                            <p className="text-center my-auto">{t("NoFeedbackYet")}</p>
                        )}
                    </>
                )}

            </div>
            {/* Write Back Response */}
            {state === "feedback" &&
                < ResponseInput request={request} onSubmit={setFeedbacks} type="register" />}
        </div>
    );
}
